/* Him.clo product page — injects the reference-design pieces Dawn doesn't ship:
   breadcrumbs, star rating, trust badges, tabbed content, related-products heart icons.
   Runs on template.name == 'product' only (bundle loaded conditionally). */

(function () {
  'use strict';

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  let initialised = false;
  function init() {
    if (initialised) return;
    initialised = true;

    // Small delay to let Dawn's own scripts finish DOM setup
    setTimeout(runAll, 100);
  }

  function runAll() {
    try { injectBreadcrumbs(); } catch (e) { console.warn('himclo breadcrumbs failed', e); }
    try { injectRating(); }      catch (e) { console.warn('himclo rating failed', e); }
    try { injectTrustBadges(); } catch (e) { console.warn('himclo trust badges failed', e); }
    try { convertAccordionsToTabs(); } catch (e) { console.warn('himclo tabs failed', e); }
    try { addHeartIconsToRelated(); }  catch (e) { console.warn('himclo hearts failed', e); }
    try { stickyMobileBuyBar(); }      catch (e) { console.warn('himclo sticky mobile bar failed', e); }
  }

  /* ------------------------------------------------------------------ */
  function stickyMobileBuyBar() {
    if (window.innerWidth >= 750) return;              // mobile only
    if (document.querySelector('.hc-sticky-buy')) return;

    const form = document.querySelector('form[action*="/cart/add"], product-form form, .product-form');
    if (!form) return;
    const addBtn = form.querySelector('button[name="add"], .product-form__submit');
    if (!addBtn) return;

    const titleEl = document.querySelector('.product__title h1, .product__title h2, .product__title');
    const priceEl = document.querySelector('.product__price .price-item--last, .product__price .price-item, .price-item--last, .price-item--regular');
    const imgEl   = document.querySelector('.product__media-item.is-active img, .product__media img');
    const title = titleEl ? titleEl.textContent.trim() : '';
    const price = priceEl ? priceEl.textContent.trim() : '';
    const imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

    const bar = document.createElement('div');
    bar.className = 'hc-sticky-buy';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `
      <div class="hc-sticky-buy__media">${imgSrc ? `<img src="${imgSrc}" alt="">` : ''}</div>
      <div class="hc-sticky-buy__info">
        <div class="hc-sticky-buy__title">${escapeHTMLLocal(title)}</div>
        <div class="hc-sticky-buy__price">${escapeHTMLLocal(price)}</div>
      </div>
      <button type="button" class="hc-sticky-buy__btn">ADD TO CART</button>
    `;
    document.body.appendChild(bar);

    // Click forwards to real add button (which triggers Dawn's product form)
    bar.querySelector('.hc-sticky-buy__btn').addEventListener('click', () => {
      addBtn.click();
    });

    // Show/hide based on whether the real form is in viewport
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          bar.removeAttribute('data-hc-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else if (e.boundingClientRect.top < 0) {
          bar.setAttribute('data-hc-visible', '');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0.1 });
    io.observe(form);
  }

  function escapeHTMLLocal(s) {
    return String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function findProductAnchor() {
    return document.querySelector('.product, section.product, main .product, .product-wrapper, [class*="section-"][class*="-padding"] .product, [id*="MainProduct"], [id*="MainContent"] > *:first-child');
  }

  /* ------------------------------------------------------------------ */
  function injectBreadcrumbs() {
    if (document.querySelector('.himclo-pd-crumbs')) return;
    const main = document.querySelector('main') || document.querySelector('#MainContent');
    const product = findProductAnchor();
    if (!product) { console.warn('himclo: no .product anchor for breadcrumbs'); return; }

    const nav = document.createElement('nav');
    nav.className = 'himclo-pd-crumbs';
    nav.setAttribute('aria-label', 'Breadcrumb');

    const path = window.location.pathname;
    const parts = path.split('/').filter(Boolean); // ['products', 'pride-chain-hoodie']
    const handle = parts[parts.length - 1] || '';

    // Try to derive a category from URL history/referrer/first collection link
    let parentTitle = '';
    let parentUrl = '';
    // If the product page was reached from a collection URL, use that
    const ref = document.referrer;
    const refMatch = ref && ref.match(/\/collections\/([^/?#]+)/);
    if (refMatch) {
      parentTitle = decodeURIComponent(refMatch[1]).replace(/-/g, ' ');
      parentUrl = '/collections/' + refMatch[1];
    } else {
      // fallback to first breadcrumb-eligible link on page (product__collections chip)
      const chip = document.querySelector('a[href^="/collections/"]:not([href="/collections/all"])');
      if (chip) {
        parentTitle = chip.textContent.trim();
        parentUrl = chip.getAttribute('href');
      }
    }

    const productTitle = (document.querySelector('.product__title h1, .product__title h2, .product__title') || {}).textContent || document.title;

    let html = '<ol><li><a href="/">Home</a></li>';
    if (parentTitle) {
      html += `<li><a href="${escapeAttr(parentUrl)}">${escapeHTML(titleCase(parentTitle))}</a></li>`;
    }
    html += `<li aria-current="page">${escapeHTML(productTitle.trim())}</li></ol>`;
    nav.innerHTML = html;

    // Insert before the product grid
    product.parentNode.insertBefore(nav, product);
  }

  /* ------------------------------------------------------------------ */
  function injectRating() {
    if (document.querySelector('.himclo-pd-rating')) return;
    const priceEl = document.querySelector('.product__price, .price, .product-form__price, .price__container, [class*="price"]:not([class*="price-item"])');
    const infoContainer = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper') || document.querySelector('.product__info') || (priceEl && priceEl.parentNode);
    if (!infoContainer) { console.warn('himclo: no info container for rating'); return; }

    // Look for existing rating value from metafield or default
    const readMeta = () => {
      const el = document.querySelector('[data-himclo-rating]');
      if (!el) return { value: 4.8, count: 124 };
      return {
        value: parseFloat(el.dataset.value || 4.8),
        count: parseInt(el.dataset.count || 124, 10),
      };
    };
    const { value, count } = readMeta();

    const wrap = document.createElement('div');
    wrap.className = 'himclo-pd-rating';
    wrap.setAttribute('aria-label', `${value} out of 5 stars, ${count} reviews`);

    const filled = Math.round(value);
    let stars = '';
    for (let i = 1; i <= 5; i++) {
      const isFilled = i <= filled;
      stars += `<svg viewBox="0 0 24 24" width="16" height="16" fill="${isFilled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><polygon points="12 2 15 8.5 22 9.3 17 14.1 18.2 21 12 17.8 5.8 21 7 14.1 2 9.3 9 8.5 12 2"/></svg>`;
    }
    wrap.innerHTML = `<span class="himclo-pd-rating__stars">${stars}</span><span class="himclo-pd-rating__value">${value}</span><span class="himclo-pd-rating__count">(${count} reviews)</span>`;

    // Insert after price
    if (priceEl && priceEl.parentNode) {
      priceEl.parentNode.insertBefore(wrap, priceEl.nextSibling);
    } else {
      infoContainer.insertBefore(wrap, infoContainer.firstChild);
    }
  }

  /* ------------------------------------------------------------------ */
  function injectTrustBadges() {
    if (document.querySelector('.himclo-pd-trust')) return;
    const submitBtn = document.querySelector('.product-form__submit, button[name="add"]');
    const productForm = document.querySelector('.product-form') || (submitBtn && submitBtn.closest('form'));
    const paymentBtn = document.querySelector('.shopify-payment-button');
    const anchor = paymentBtn || productForm || submitBtn;
    if (!anchor || !anchor.parentNode) { console.warn('himclo: no buy button anchor for trust badges'); return; }

    const trust = document.createElement('div');
    trust.className = 'himclo-pd-trust';
    trust.innerHTML = `
      <div class="himclo-pd-trust__item">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v10H3z"/><path d="M14 10h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>
        <div><div class="himclo-pd-trust__title">Free Shipping</div><div class="himclo-pd-trust__sub">On orders over $150</div></div>
      </div>
      <div class="himclo-pd-trust__item">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>
        <div><div class="himclo-pd-trust__title">Easy Returns</div><div class="himclo-pd-trust__sub">30-day returns</div></div>
      </div>
      <div class="himclo-pd-trust__item">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
        <div><div class="himclo-pd-trust__title">Secure Checkout</div><div class="himclo-pd-trust__sub">Encrypted payments</div></div>
      </div>
      <div class="himclo-pd-trust__item">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a13 13 0 0 1 0 18a13 13 0 0 1 0-18z"/></svg>
        <div><div class="himclo-pd-trust__title">Worldwide Shipping</div><div class="himclo-pd-trust__sub">Delivered anywhere</div></div>
      </div>
    `;
    // Insert AFTER the payment button block (or after the form) so it sits under all buy buttons
    if (anchor.parentNode) {
      anchor.parentNode.insertBefore(trust, anchor.nextSibling);
    }
  }

  /* ------------------------------------------------------------------ */
  function convertAccordionsToTabs() {
    if (document.querySelector('.himclo-pd-tabs')) return;

    // Collect Dawn accordions on the product page
    const accordions = Array.from(document.querySelectorAll('.product__accordion, .product__accordion details, .product__block details'));
    if (!accordions.length) {
      // Build synthetic tabs from product description if no accordions
      const desc = document.querySelector('.product__description');
      if (!desc) return;
      buildSyntheticTabs(desc);
      return;
    }

    // Wrap all accordions into a tabs container
    const container = document.createElement('section');
    container.className = 'himclo-pd-tabs';

    const nav = document.createElement('div');
    nav.className = 'himclo-pd-tabs__nav';
    nav.setAttribute('role', 'tablist');

    const panels = document.createElement('div');
    panels.className = 'himclo-pd-tabs__panels';

    accordions.forEach((acc, i) => {
      const summary = acc.querySelector('summary');
      const titleEl = summary && (summary.querySelector('h2, h3, .accordion__title, .product__accordion__title') || summary);
      const title = (titleEl ? titleEl.textContent : `Tab ${i + 1}`).trim();

      // Get the content (everything inside details except summary)
      const contentNodes = Array.from(acc.childNodes).filter(n => !(n.nodeType === 1 && n.tagName.toLowerCase() === 'summary'));

      const tabBtn = document.createElement('button');
      tabBtn.type = 'button';
      tabBtn.className = 'himclo-pd-tabs__btn' + (i === 0 ? ' himclo-pd-tabs__btn--active' : '');
      tabBtn.setAttribute('role', 'tab');
      tabBtn.dataset.tabIndex = i;
      tabBtn.textContent = title.toUpperCase();
      nav.appendChild(tabBtn);

      const panel = document.createElement('div');
      panel.className = 'himclo-pd-tabs__panel' + (i === 0 ? ' himclo-pd-tabs__panel--active' : '');
      panel.setAttribute('role', 'tabpanel');
      panel.dataset.tabIndex = i;
      contentNodes.forEach(n => panel.appendChild(n.cloneNode(true)));
      panels.appendChild(panel);
    });

    container.appendChild(nav);
    container.appendChild(panels);

    // Remove the original accordions
    accordions.forEach((a) => {
      if (a.parentNode) a.parentNode.removeChild(a);
    });

    // Insert tabs after the product info
    const anchor = findProductAnchor() || document.querySelector('main');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(container, anchor.nextSibling);
    }

    // Wire tab clicks
    nav.addEventListener('click', (e) => {
      const btn = e.target.closest('.himclo-pd-tabs__btn');
      if (!btn) return;
      const idx = btn.dataset.tabIndex;
      nav.querySelectorAll('.himclo-pd-tabs__btn').forEach(b => b.classList.toggle('himclo-pd-tabs__btn--active', b === btn));
      panels.querySelectorAll('.himclo-pd-tabs__panel').forEach(p => p.classList.toggle('himclo-pd-tabs__panel--active', p.dataset.tabIndex === idx));
    });
  }

  function buildSyntheticTabs(descEl) {
    const container = document.createElement('section');
    container.className = 'himclo-pd-tabs';
    container.innerHTML = `
      <div class="himclo-pd-tabs__nav" role="tablist">
        <button type="button" class="himclo-pd-tabs__btn himclo-pd-tabs__btn--active" data-tab-index="0">DESCRIPTION</button>
        <button type="button" class="himclo-pd-tabs__btn" data-tab-index="1">DETAILS</button>
        <button type="button" class="himclo-pd-tabs__btn" data-tab-index="2">SIZE &amp; FIT</button>
        <button type="button" class="himclo-pd-tabs__btn" data-tab-index="3">SHIPPING &amp; RETURNS</button>
      </div>
      <div class="himclo-pd-tabs__panels">
        <div class="himclo-pd-tabs__panel himclo-pd-tabs__panel--active" data-tab-index="0">${descEl.innerHTML}</div>
        <div class="himclo-pd-tabs__panel" data-tab-index="1"><p>Premium heavyweight cotton, oversized fit, tonal print, ribbed cuffs and hem, chain detail.</p></div>
        <div class="himclo-pd-tabs__panel" data-tab-index="2"><p>Model is 5'6" (168 cm) and wearing size M. Runs true to size — if between sizes, size up for a relaxed fit.</p></div>
        <div class="himclo-pd-tabs__panel" data-tab-index="3"><p>Free shipping on orders over $150. Standard delivery in 3-5 business days. Free returns within 30 days.</p></div>
      </div>
    `;
    const anchor = findProductAnchor();
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(container, anchor.nextSibling);

    const nav = container.querySelector('.himclo-pd-tabs__nav');
    const panels = container.querySelector('.himclo-pd-tabs__panels');
    nav.addEventListener('click', (e) => {
      const btn = e.target.closest('.himclo-pd-tabs__btn');
      if (!btn) return;
      const idx = btn.dataset.tabIndex;
      nav.querySelectorAll('.himclo-pd-tabs__btn').forEach(b => b.classList.toggle('himclo-pd-tabs__btn--active', b === btn));
      panels.querySelectorAll('.himclo-pd-tabs__panel').forEach(p => p.classList.toggle('himclo-pd-tabs__panel--active', p.dataset.tabIndex === idx));
    });
  }

  /* ------------------------------------------------------------------ */
  function addHeartIconsToRelated() {
    const cards = document.querySelectorAll('.related-products .card-wrapper, .related-products .product-card-wrapper');
    cards.forEach((card) => {
      if (card.querySelector('.himclo-pd-heart')) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'himclo-pd-heart';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        btn.classList.toggle('himclo-pd-heart--active');
      });
      card.appendChild(btn);
      card.style.position = 'relative';
    });
  }

  /* ------------------------------------------------------------------ */
  function escapeHTML(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
  function escapeAttr(s) { return escapeHTML(s); }
  function titleCase(s) { return s.replace(/\b\w/g, c => c.toUpperCase()); }
})();
